/**
 * Klaviyo behavioral events for Horizon theme.
 * Depends on window.KlaviyoTheme from snippets/klaviyo-theme-data.liquid.
 */
(function () {
  'use strict';

  var cfg = window.KlaviyoTheme;
  if (!cfg || !cfg.enabled) return;

  function whenKlaviyoReady(cb) {
    var k = window.klaviyo;
    if (k && typeof k.track === 'function') {
      cb(k);
      return;
    }
    var n = 0;
    var id = window.setInterval(function () {
      k = window.klaviyo;
      if (k && typeof k.track === 'function') {
        window.clearInterval(id);
        cb(k);
      } else if (++n > 200) {
        window.clearInterval(id);
      }
    }, 50);
  }

  function absUrl(u) {
    if (!u) return '';
    var s = String(u);
    if (s.indexOf('//') === 0) return 'https:' + s;
    if (s.indexOf('http') === 0) return s;
    return window.location.origin + (s.charAt(0) === '/' ? '' : '/') + s;
  }

  function imageFromVariant(variant, fallback) {
    if (!variant) return fallback || '';
    var fm = variant.featured_media;
    if (fm && fm.preview_image && fm.preview_image.src) return absUrl(fm.preview_image.src);
    if (variant.featured_image && variant.featured_image.src) return absUrl(variant.featured_image.src);
    return fallback || '';
  }

  function trackProductView(payload) {
    whenKlaviyoReady(function (klaviyo) {
      klaviyo.track('Viewed Product', payload);
    });
  }

  function buildViewedProductFromVariant(variant, base) {
    if (!variant || !base) return null;
    var price = variant.price != null ? variant.price / 100 : null;
    var compare =
      variant.compare_at_price != null && variant.compare_at_price > 0
        ? variant.compare_at_price / 100
        : null;
    var categories = base.Categories;
    var url =
      base.URLPrefix && variant.id != null ? base.URLPrefix + String(variant.id) : window.location.href;

    return {
      ProductName: base.ProductName,
      ProductID: base.ProductID,
      SKU: variant.sku || '',
      Categories: categories,
      ImageURL: imageFromVariant(variant, base.ImageURL),
      URL: url,
      Price: price,
      CompareAtPrice: compare,
      Brand: base.Brand,
      $value: price != null ? price : undefined,
    };
  }

  if (cfg.productView) {
    trackProductView(cfg.productView);
  }

  if (cfg.onProductPage && cfg.productBase) {
    document.addEventListener(
      'variant:update',
      function (e) {
        var v = e.detail && e.detail.resource;
        var payload = buildViewedProductFromVariant(v, cfg.productBase);
        if (payload) trackProductView(payload);
      },
      { passive: true }
    );
  }

  function findLineItem(items, variantId) {
    if (!items || !items.length) return null;
    if (!variantId) return items[items.length - 1];
    var vid = String(variantId);
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === vid) return items[i];
    }
    return items[items.length - 1];
  }

  function buildAddedToCartPayload(line, cart) {
    var qty = line.quantity || 1;
    var lineTotal = (line.final_line_price != null ? line.final_line_price : line.line_price) / 100;
    var unit = lineTotal / qty;

    var names = cart.items.map(function (i) {
      return i.product_title || i.title || '';
    });

    var img = line.image;
    if (img && img.indexOf('//') === 0) img = 'https:' + img;

    var lineUrl = line.url ? absUrl(line.url) : '';

    return {
      $value: lineTotal,
      AddedItemProductName: line.product_title || line.title || '',
      AddedItemProductID: line.product_id,
      AddedItemSKU: line.sku || '',
      AddedItemCategories: [],
      AddedItemImageURL: img || '',
      AddedItemURL: lineUrl,
      AddedItemPrice: unit,
      AddedItemQuantity: qty,
      ItemNames: names,
      ItemCount: cart.item_count,
      Categories: [],
    };
  }

  document.addEventListener(
    'cart:update',
    function (e) {
      var d = e.detail;
      if (!d || !d.data || d.data.didError) return;

      var src = d.data.source;
      if (src !== 'product-form-component') return;

      var cart = d.resource;
      if (!cart || !cart.items || !cart.items.length) return;

      var variantId = d.sourceId;
      var line = findLineItem(cart.items, variantId);
      if (!line) return;

      whenKlaviyoReady(function (klaviyo) {
        klaviyo.track('Added to Cart', buildAddedToCartPayload(line, cart));
      });
    },
    { passive: true }
  );

  function buildCartPagePayload(cart) {
    var items = (cart.items || []).map(function (line) {
      var qty = line.quantity || 1;
      var lineTotal = (line.final_line_price != null ? line.final_line_price : line.line_price) / 100;
      return {
        ProductID: line.product_id,
        VariantID: line.variant_id,
        ProductName: line.product_title || line.title || '',
        SKU: line.sku || '',
        Quantity: qty,
        ItemPrice: lineTotal / qty,
        RowTotal: lineTotal,
      };
    });

    var names = (cart.items || []).map(function (i) {
      return i.product_title || i.title || '';
    });

    return {
      $value: cart.total_price / 100,
      ItemCount: cart.item_count,
      ItemNames: names,
      Categories: [],
      Items: items,
    };
  }

  if (cfg.cartPage && cfg.cartSnapshot) {
    whenKlaviyoReady(function (klaviyo) {
      klaviyo.track('Viewed Cart', buildCartPagePayload(cfg.cartSnapshot));
    });
  }

  if (cfg.customer && cfg.customer.$email) {
    whenKlaviyoReady(function (klaviyo) {
      if (typeof klaviyo.identify === 'function') {
        klaviyo.identify(cfg.customer);
      }
    });
  }
})();
